import { DomainAction } from '../index'

const domain = "DataProvider"

export const DataProvider = {
    findUser: new DomainAction(domain, 'FindUser', DomainAction.methods.get),
    getFilters: new DomainAction(domain, 'GetFiltersWithValues', DomainAction.methods.get),
}